import React from "react";
import { RichTextEditor } from "../../../components/RichTextEditor";
import * as S from "../styles";
import ListsSection from "./ListsSection";

const API_URL = process.env.REACT_APP_API_URL || "";

const BlockFields = ({
  formData,
  papers,
  blocks,
  firstImage,
  setFormData,
  handleSaveBlock,
  handleOriginalClick,
  saving,
  showMessage,
  blockLists,
  listTitles,
  draggedList,
  activeListDropZone,
  newListTitle,
  showAddListModal,
  handleListTitleChange,
  handleListTitleBlur,
  handleDeleteList,
  handleListDragStart,
  handleListDragEnd,
  handleListZoneDragOver,
  handleListZoneDragLeave,
  handleListZoneDrop,
  setNewListTitle,
  setShowAddListModal,
  handleCreateNewList,
}) => {
  return (
    <S.Section>
      <S.SectionTitle>Редактор</S.SectionTitle>
      <S.FormGrid>
        <S.FormGroup>
          <S.Label>Тип бумаги</S.Label>
          <S.Select
            value={formData.paperId}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, paperId: e.target.value }))
            }
          >
            {papers.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </S.Select>
        </S.FormGroup>

        <S.FormGroup>
          <S.Label>Название узора (основной термин)</S.Label>
          <S.Input
            type="text"
            value={formData.title}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, title: e.target.value }))
            }
          />
        </S.FormGroup>

        <S.FormGroup className="full-width">
          <S.Label>Дополнительные термины ({blockLists.length})</S.Label>
          <ListsSection
            blockLists={blockLists}
            listTitles={listTitles}
            draggedList={draggedList}
            activeListDropZone={activeListDropZone}
            newListTitle={newListTitle}
            showAddListModal={showAddListModal}
            handleListTitleChange={handleListTitleChange}
            handleListTitleBlur={handleListTitleBlur}
            handleDeleteList={handleDeleteList}
            handleListDragStart={handleListDragStart}
            handleListDragEnd={handleListDragEnd}
            handleListZoneDragOver={handleListZoneDragOver}
            handleListZoneDragLeave={handleListZoneDragLeave}
            handleListZoneDrop={handleListZoneDrop}
            setNewListTitle={setNewListTitle}
            setShowAddListModal={setShowAddListModal}
            handleCreateNewList={handleCreateNewList}
          />
        </S.FormGroup>

        <S.FormGroup className="full-width">
          <S.Label>Текст статьи</S.Label>
          <RichTextEditor
            value={formData.text}
            blocks={blocks}
            showMessage={showMessage}
            onChange={(html) =>
              setFormData((prev) => ({ ...prev, text: html }))
            }
          />
        </S.FormGroup>

        <S.FormGroup className="full-width">
          <S.Label>Фраза после текста</S.Label>
          <RichTextEditor
            value={formData.credential}
            showMessage={showMessage}
            onChange={(html) =>
              setFormData((prev) => ({ ...prev, credential: html }))
            }
          />
        </S.FormGroup>

        <S.FormGroup>
          <S.Label>Цвет</S.Label>
          <div style={{ display: "flex", columnGap: 5 }}>
            <span
              style={{
                display: "inline-block",
                width: 20,
                height: "auto",
                background: formData.color,
                border: "1px solid #ddd",
                borderRadius: "4px",
              }}
            />
            <S.Input
              type="text"
              value={formData.color}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, color: e.target.value }))
              }
            />
          </div>
        </S.FormGroup>
      </S.FormGrid>

      {/* Original Preview */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 15,
        }}
      >
        <S.Label>Главное изображение</S.Label>
        <span
          style={{
            fontSize: "13px",
            padding: "4px 8px",
            borderRadius: "4px",
            border: `1px solid ${formData.color}`,
            color: formData.color,
            margin: "10px 0",
          }}
        >
          Если изображение не установлено, ставим 1-е из списка
        </span>

        <S.OriginalPreview>
          <S.PreviewImageWrapper onClick={handleOriginalClick}>
            <S.PreviewImage
              src={`${API_URL}/images/${formData.original || firstImage}`}
              alt="original"
            />
            <S.PreviewOverlay>Нажмите для замены</S.PreviewOverlay>
          </S.PreviewImageWrapper>
        </S.OriginalPreview>
      </div>

      <S.SaveButton onClick={handleSaveBlock} disabled={saving}>
        {saving ? "Сохранение..." : "Сохранить изменения"}
      </S.SaveButton>
    </S.Section>
  );
};

export default BlockFields;
